export default __webpack_public_path__ + "static/mobile-apps-image-1-50c9c16da1861418219db3f951a3825f.jpg";